import { useEffect, useState } from "react";
import { motion, AnimatePresence } from "framer-motion";
import { Menu, X } from "lucide-react";

const LINKS = [
  { label: "About", href: "#about" },
  { label: "Projects", href: "#projects" },
  { label: "Partnerships", href: "#partnerships" },
  { label: "Companies", href: "#companies" },
  { label: "Contact", href: "#contact" },
];

const Wordmark = () => (
  <a href="#top" data-testid="nav-logo" className="group leading-[0.92]">
    <span className="block font-display text-xl md:text-2xl tracking-wide text-royal">
      Titanium
    </span>
    <span className="block font-display italic text-xl md:text-2xl tracking-wide text-gold-gradient">
      Wealth
    </span>
  </a>
);

const Navbar = () => {
  const [scrolled, setScrolled] = useState(false);
  const [open, setOpen] = useState(false);

  useEffect(() => {
    const onScroll = () => setScrolled(window.scrollY > 40);
    window.addEventListener("scroll", onScroll);
    return () => window.removeEventListener("scroll", onScroll);
  }, []);

  return (
    <motion.header
      data-testid="main-navbar"
      initial={{ y: -80, opacity: 0 }}
      animate={{ y: 0, opacity: 1 }}
      transition={{ duration: 0.7, ease: "easeOut" }}
      className={`fixed top-0 left-0 right-0 z-50 transition-all duration-500 ${
        scrolled
          ? "glass-light border-b border-royal/10 py-4"
          : "bg-transparent py-6"
      }`}
    >
      <div className="px-6 md:px-12 lg:px-24 flex items-center justify-between">
        <Wordmark />

        <nav className="hidden md:flex items-center gap-9">
          {LINKS.map((l) => (
            <a
              key={l.href}
              href={l.href}
              data-testid={`nav-link-${l.label.toLowerCase()}`}
              className="font-accent text-base font-medium uppercase tracking-[0.16em] text-royal hover:text-gold transition-colors duration-300"
            >
              {l.label}
            </a>
          ))}
          <a
            href="#contact"
            data-testid="nav-cta"
            className="font-accent text-sm uppercase tracking-[0.18em] bg-royal text-beige-light px-6 py-3 hover:bg-gold transition-all duration-300"
          >
            Partner With Us
          </a>
        </nav>

        <button
          data-testid="mobile-menu-toggle"
          className="md:hidden text-royal"
          onClick={() => setOpen((v) => !v)}
          aria-label="Toggle menu"
        >
          {open ? <X size={26} /> : <Menu size={26} />}
        </button>
      </div>

      <AnimatePresence>
        {open && (
          <motion.div
            data-testid="mobile-menu"
            initial={{ height: 0, opacity: 0 }}
            animate={{ height: "auto", opacity: 1 }}
            exit={{ height: 0, opacity: 0 }}
            transition={{ duration: 0.4 }}
            className="md:hidden overflow-hidden bg-beige-light/95 backdrop-blur-xl border-t border-royal/10 mt-4"
          >
            <div className="flex flex-col px-6 py-6 gap-5">
              {LINKS.map((l) => (
                <a
                  key={l.href}
                  href={l.href}
                  onClick={() => setOpen(false)}
                  className="font-accent text-base uppercase tracking-[0.18em] text-royal/80 hover:text-gold"
                >
                  {l.label}
                </a>
              ))}
            </div>
          </motion.div>
        )}
      </AnimatePresence>
    </motion.header>
  );
};

export default Navbar;
